import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';

import { ConnectivityRankingPositions } from '@store';
import { CommonStandaloneModule } from '../../common-standalone.module';

import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-connectivity-ranking',
  templateUrl: './connectivity-ranking.component.html',
  styleUrls: ['./connectivity-ranking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonStandaloneModule, MatIconModule, MatTooltipModule],
})
export class ConnectivityRankingComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() rankingPositions: ConnectivityRankingPositions;
  @Input() lightTheme = false;
}
